import React from 'react';
import { STATIC_INDICATION_TYPES, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const byHourReportDataNotAvailableIndication = {
    staticIndicationType: STATIC_INDICATION_TYPES.PARTIAL_REPORT_DATA,
    type: INDICATION_TYPES.WARNING,
    iconTypeOverride: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.byHourReportDataNotAvailableWarning.highlight"
            defaultMessage="Limited Data Availability"
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.byHourReportDataNotAvailableWarning.message"
            defaultMessage="The By-Hour report is limited to the last 90 days. Older data may not be available."
        />
    ),
};
